
export default {
    name: 'ApplicationTimer',
    props: {
        date: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            currentDate: new Date(),
            timer: null
        }
    },
    computed: {
        endDate() {
            return new Date(this.date)
        },
        leftTime() {
            if (new Date() > this.endDate) {
                return `0 дн 0 ч 0 мин`
            } else {
                const totalSeconds = Math.floor((this.endDate - (this.currentDate)) / 1000)
                const totalMinutes = Math.floor(totalSeconds / 60)
                const totalHours = Math.floor(totalMinutes / 60)
                const totalDays = Math.floor(totalHours / 24)

                const hours   = totalHours - ( totalDays * 24 )
                const minutes = totalMinutes - ( totalDays * 24 * 60 ) - ( hours * 60 )
                const seconds = totalSeconds - ( totalDays * 24 * 60 * 60 ) - ( hours * 60 * 60 ) - ( minutes * 60 )

                return `${totalDays.toString()} дн ${hours.toString()} ч ${minutes.toString()} мин`
            }
        },
    },
    created() {
        this.timer = setInterval(() => {
            this.tick()
        }, 1000)
    },
    beforeDestroy() {
        if (this.timer) clearInterval(this.timer);
    },
    methods: {
        tick() {
            this.currentDate = new Date()
        }
    }
}
